import React from 'react';
import {Button, Grid, Typography} from '@material-ui/core';
import {ImportStepper} from '@backstage/plugin-catalog-import';

type RegisterStepProps = {
  repoUrl: string;
  mainBranch: string;
  onBack: () => void;
};

/**
 * Hands off to the stock catalog-import Analyze/Import flow, with the URL
 * pre-filled since we already know exactly where catalog-info.yaml lives on
 * the repo's default branch -- the user just has to click Analyze and
 * Import.
 */
export const RegisterStep = ({repoUrl, mainBranch, onBack}: RegisterStepProps) => {
  const fileUrl = `${repoUrl}/src/${mainBranch}/catalog-info.yaml`;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant='body1'>
          Now that catalog-info.yaml has been merged into <strong>{repoUrl}</strong>, analyze the
          repository to add it to the catalog.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <ImportStepper initialUrl={fileUrl} />
      </Grid>
      <Grid item xs={12}>
        <Button onClick={onBack}>Back</Button>
      </Grid>
    </Grid>
  );
};
